// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4785":"5232605c","9446":"1368668e"}[chunkId] + ".chunk.css";
};